import { useEffect, useState } from 'react';

import Loader from 'components/Loader';
import { useActions } from 'hooks/useActions';
import { useAuth } from 'providers/Auth';
import { getOrCreateUser } from 'store/actions/auth';

import './App.css';

function AuthWrapper({ children }) {
    const { auth, profile } = useAuth();
    const { userId, accessToken } = auth;

    const [actionGetOrCreateUser] = useActions([getOrCreateUser]);
    const [isFetched, setIsFetched] = useState(false);

    const checkUser = async () => {
        await actionGetOrCreateUser(userId, JSON.stringify({ accessToken, lineId: userId, profile }));
        setIsFetched(true);
    };

    useEffect(() => {
        async function init() {
            setIsFetched(false);
            if (userId) await checkUser();
        }
        init();
    }, [userId]);

    if (!isFetched) return <Loader />;
    return <>{userId && children}</>;
}

export default AuthWrapper;
